/* eslint-disable @atlaskit/design-system/no-unsafe-style-overrides */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import RovoLogoHolidayMomentDark from './RovoLogoHolidayMomentDark.gif';
import RovoLogoHolidayMomentLight from './RovoLogoHolidayMomentLight.gif';

const styles = cssMap({
	imageWrapper: {
		position: 'absolute',
		inset: '0',
		width: '100%',
		height: '100%',
		overflow: 'hidden',
		borderRadius: token('radius.xxlarge'),
	},
	image: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		borderRadius: token('radius.xxlarge'),
	},
});

export const RovoLogoHoliday = (): React.JSX.Element => (
	<div css={styles.imageWrapper}>
		<Image
			css={styles.image}
			src={RovoLogoHolidayMomentLight}
			srcDark={RovoLogoHolidayMomentDark}
			alt="Rovo Holiday Logo"
		/>
	</div>
);
